import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { Link as ReachLink } from '@reach/router';

import ShipmentStore from 'js/stores/pages/AdminDashboardPage/ShipmentStore';
import { formatCurrency } from 'js/services/Format';
import { adminPanelColor } from 'js/config/style';

import CountDown from 'js/components/core/CountDown';
import LoadingSpinner from '../../LoadingSpinner';
import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import DropMenu from '../../DashPanel/DropMenu';

import Link from './Link';
import Icon from './Icon';
import Title from './Title';
import Text from './Text';

import Card from './Card';
import Display from './Display';
import Image from './Image';
import Details from './Details';
import Label from './Label';
import TrackEvent from './TrackEvent';

import List from '../../List';
import Row from '../../List/Row';
import ListMessage from '../../List/ListMessage';
import Order from '../../Display/Order';

@observer
export default class Shipment extends Component {
  shipment = ShipmentStore.create({ id: parseInt(this.props['*']) });

  constructor(props) {
    super(props);
    this.shipment.load();
  }

  render() {
    const shipment = this.shipment;
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>
            <Link to="/admin/shipments">Shipments</Link>
            {shipment.order_item && (
              <>
                <Icon name="chevron-right" />
                <Text>
                  {shipment.order_item} ({shipment.shipper})
                </Text>
              </>
            )}
          </Title>
        </Header>

        <Provider model={shipment}>
          <Content background={adminPanelColor}>
            {this.shipment.isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Card>
                  <Display>
                    <Image />
                  </Display>

                  <Details>
                    <Label>Last updated</Label>
                    <div>{shipment.updated_at}</div>

                    <Label>Direction</Label>
                    <div>{shipment.human_direction}</div>

                    <Label>Shipping</Label>
                    <div>
                      {shipment.shipper} ({formatCurrency(shipment.rate)})
                    </div>

                    <Label>Status</Label>
                    <div>
                      <div>{shipment.human_status}</div>

                      {shipment.status === 'pending' && (
                        <CountDown remaining={shipment.seconds_until_expiration}>
                          {({ status, duration, timeLeft, Remaining }) =>
                            status === 'expired' ? (
                              <>
                                (shipment{' '}
                                <Remaining status={status} title={shipment.expiration_time}>
                                  expired
                                </Remaining>
                                )
                              </>
                            ) : (
                              <>
                                (expires in{' '}
                                <Remaining status={status} title={shipment.expiration_time}>
                                  {status === 'warn' ? timeLeft : duration.humanize()}
                                </Remaining>
                                )
                              </>
                            )
                          }
                        </CountDown>
                      )}
                    </div>

                    <Label>Tracking</Label>
                    <div>
                      <a href={shipment.tracking_url} target="_blank">
                        {shipment.tracking_number}
                      </a>
                    </div>

                    <Label>From</Label>
                    <div>
                      <ReachLink to={`/admin/users/user/${shipment.from_email}`}>{shipment.from_name}</ReachLink>
                      <div>{shipment.from_address}</div>
                    </div>

                    <Label>To</Label>
                    <div>
                      <ReachLink to={`/admin/users/user/${shipment.to_email}`}>{shipment.to_name}</ReachLink>
                      <div>{shipment.to_address}</div>
                    </div>
                  </Details>
                </Card>

                <div>
                  <Row cols={2}>
                    <Order load={{ shipment_id: shipment.id }} title="Order" />
                    <List paginator={shipment.tracking_updates} title="Tracking updates" icon="list" controls="more">
                      <div>
                        {shipment.tracking_updates.updates.length ? (
                          shipment.tracking_updates.updates.map((trackEvent, index) => (
                            <TrackEvent event={trackEvent} key={index} />
                          ))
                        ) : (
                          <ListMessage>No tracking updates found</ListMessage>
                        )}
                      </div>
                    </List>
                  </Row>
                </div>
              </>
            )}
          </Content>
        </Provider>
      </DashPanel>
    );
  }
}
